// assets
import { FolderOpenOutlined, ClockCircleOutlined, FileTextOutlined } from '@ant-design/icons';

// icons
const icons = {
  FolderOpenOutlined,
  ClockCircleOutlined,
  FileTextOutlined
};

const client = {
  id: 'client',
  title: '',
  type: 'group',
  roles: ['client'], // Only clients can see this group
  children: [
    {
      id: 'billing-invoices',
      title: 'My Invoices',
      type: 'item',
      url: '/client/billing-invoices',
      icon: icons.FileTextOutlined
    },
    {
      id: 'timesheets',
      title: 'Timesheets',
      type: 'item',
      url: '/client/timesheets',
      icon: icons.ClockCircleOutlined
    }
  ]
};

export default client;
